import React, {Component} from 'react';
import '../assets/custom.css';
import '../assets/teachers.css';
import '../assets/apps.css';
import REST from "../Shared/REST";
import Helpers from "../Shared/Helpers";
import {Buttons, Buttons1, CountDownComponent, LevelAnimation, LevelTrackerComponent, VideoComponent} from "./Common";
import {isTablet, isIOS, isMobile,isIOS13} from "react-device-detect";
import "../assets/students/Slash.css";
import Tappable from 'react-tappable';
import {clearInterval, setInterval} from "timers";
import {Modal} from "react-bootstrap";
import {withRouter} from "react-router-dom";
import ReactDOM from 'react-dom';
import ProgressBox from "../ProgressModalComponent/ProgressBox";
import ScoreBox from "../ProgressModalComponent/ScoreBox";
import DialogBox from "../Shared/DialogBox";
import videoInstructionPN from "../assets/images/video_instructions.png";
import InstructionModals from "../Shared/InstructionModals";
import iconCorrect from '../assets/images/modal_correct.png';
import iconIncorrect from '../assets/images/modal_incorrect.png';
import TRACKING from "../Shared/DataTrackingPoints";
import {updateAppStates, updateStudentAccountTab, updateStudentAppsStatus} from "./actions";
import connect from "react-redux/es/connect/connect";

let usedPassages = [];
let MaxSessionTime = 60; //60 seconds, for testing: 6000 seconds

class SlashTestComponent extends Component {

    constructor(props) {
        super(props);
        this.state = {
            active: 0,
            passages: [],
            modalActive:true,
            loadedScores: false,
            startDisabled:true,
            bestScores: {
                slashLevel: 1,
                slashScore: 1
            }
        };
    }

    async componentDidMount() {
        Helpers.authorize(this);
        await REST.getBestScores().then(async (response) => {
            if (response.success) {
                await this.setState({
                    loadedScores: true,
                    bestScores: response.body
                });
            }
        });
    }

    handleModalBack = (modalActive) => {
        this.setState({modalActive: modalActive});
    };

    handleBack = () => {
        console.log('HandleBack-Slash');
        window.location.reload();
        this.setState({active: 0});
    };

    handleActive = async (active) => {
        if(active===3){
            await REST.getSlashTestRandom().then(function (response) {
                if (response.success) {
                    this.setState({passages: response.body.passages});
                } else {
                    console.log('Error', response.msg);
                }
            }.bind(this), (error) => {
                console.log('Error', error.msg);
            });
        }
        this.setState({active: active});

    };

    handleBeginTest = () => {
        this.setState({active: 3});
    };

    changeLevelScore = (newLevel, newScore) =>{
        this.state.bestScores.slashLevel = newLevel;
        this.state.bestScores.slashScore = newScore;
    };

    render() {
        return (
            <div className={this.state.active !== 2 ? "bgGrey SlashContainer" : "SlashContainer bgYellow"}>
                {
                    this.state.active === 0 ?
                        <div>
                            <div className="section appSection bgGrey">
                                <div className={"container"}>
                                    <div className="appContainer slash">
                                        <h1 style={{textAlign: "center",fontSize:42}}>Slash</h1>
                                        <div className={"row"} style={{display: "flex", alignItems: "center"}}>
                                            <div className={"col-xs-12 text-center"}>
                                                {
                                                    this.state.loadedScores ?
                                                    <ProgressBox
                                                        appName={"slash"}
                                                        slashProgress={true}
                                                        level={this.state.bestScores.slashLevel}
                                                        step={this.state.bestScores.slashScore}
                                                        steps={6}
                                                        maxLevel={8}
                                                    />
                                                        : null
                                                }
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <Buttons appName={"slash"} level={this.state.bestScores.slashLevel}  maxLevel={8} buttonClick={this.handleActive} currentTabActive={this.state.active}/>
                        </div>
                        : null
                }
                {
                    this.state.active === 1 ?
                        <div>
                            <div className={"appSection bgGrey"}>
                                <div className="container">
                                    <Buttons1 demo appName={"slash"} practice buttonClick={this.handleActive} currentTabActive={this.state.active} />

                                    <div className="appContainer slash">
                                        <h1 style={{textAlign: "center",fontSize:42}}>Slash: Show Me</h1>
                                        <div className={"row"} style={{display: "flex", alignItems: "center"}}>
                                            <div className={"col-xs-12 centerBlock"}>
                                                <VideoComponent url={"https://s3.us-east-2.amazonaws.com/uploadbeta/video/slash/new_slash_video.mp4"}/>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <Buttons demo appName={"slash"} buttonClick={this.handleActive} currentTabActive={this.state.active}/>
                        </div>
                        : null
                }

                {
                    this.state.active === 2 ?
                        <div>
                            <Buttons1 appName={"slash"} practice buttonClick={this.handleActive} currentTabActive={this.state.active} />
                            <Tutorial studentUser={this.props.studentUser} buttonClick={this.handleActive} passage={this.state.passages[0]} beginTest={this.handleBeginTest}/>
                            <Buttons appName={"slash"} buttonClick={this.handleActive} currentTabActive={this.state.active}/>
                        </div> : null
                }
                {
                    this.state.active === 3 ?
                        <div>
                            <Buttons1 appName={"slash"} buttonClick={this.handleActive} clickBack={this.handleBack} recordedSession={this.state.modalActive} currentTabActive={this.state.active} />
                            <Content studentUser={this.props.studentUser} buttonClick={this.handleActive} backBtn={this.handleModalBack} changeLevelScore={this.changeLevelScore} passages={this.state.passages}/>
                            <Buttons appName={"slash"} buttonClick={this.handleActive} currentTabActive={this.state.active}/>
                        </div>: null
                }
            </div>
        )
    }
}

const style = {
    display: '-webkit-box'
};

class ContentComponent extends Component {
    constructor(props) {
        super(props);
        this.state = {
            popupSurvey: false,
            passages: this.props.passages,
            passage: this.props.passages[0],
            expected: [],
            expectedToPop: [],
            level: 1,
            score: 3,
            testScore: 0,
            time: MaxSessionTime,
            sessionTime: MaxSessionTime,
            response: [],
            generatedResponse: '',
            errors: [],
            correct: 0,
            error: 0,
            skipped: 0,
            isNewLevel: true,
            finished: false,
            showNext: false,
            errorType: '',
            lastOffset: -1,
            levelCal: null,
            scoreCalc: null,
            isNewLevelCalc:null,
            animateLevel:false,
            levelType:'',
            stepType:'',
            modalDialog: false,
            responseContent:'',
            randomCorrect: ['Great Job','Well Done','Fantastic','You got it','Perfect','Way to go','Terrific','Excellent','Super','Nice work','Wonderful','Outstanding','Congratulations','That’s right'],
            randomTitle: '',
            stepDir:'UP',
            stepDirNow: null,
            firstScore:false,
            lastScore:false,
            tooFast: false,
            modalInstruction: false
        };
        this.timer = 0;
        this.handleSurveyBack = this.handleSurveyBack.bind(this);
        this.handleFinished = this.handleFinished.bind(this);
        this.handleNext = this.handleNext.bind(this);
        this.handleLevelAnimationClose = this.handleLevelAnimationClose.bind(this);
        this.startTimer = this.startTimer.bind(this);
        this.countDown = this.countDown.bind(this);
        this.handleClose = this.handleClose.bind(this);
        this.theEventListener = this.windowResizeListener.bind(this);
        this.handleAnalytics = this.handleAnalytics.bind(this);
    }

    handleAnalytics(){
        let analytics = this.state.analytics;
        REST.addAnalytics(analytics).then(res => {});
    }

    windowResizeListener = (e) => {
        if(!(isTablet||isMobile||isIOS||isIOS13)) {
            this.setState({
                modalDialog: true,
                responseContent: 'Resizing the browser window while in a test is not allowed.'
            });
        }
    };

    componentWillUnmount() {
        window.removeEventListener('resize', this.theEventListener, true);
        clearInterval(this.timer);
    }

    async componentDidMount() {
        if(window.innerWidth < window.innerHeight){
            this.setState({
                modalInstruction:true
            });
        }else{
            this.setState({
                modalInstruction:false
            });
        REST.getBestScores().then((response) => {
            if (response.success) {
                this.setState({
                    level: response.body.slashLevel,
                    score: response.body.slashScore,
                    expected: this.calculateExpected(),//?
                    expectedToPop: [],
                    lineWidth:null, //?
                    generatedResponse: this.removeSpaces(this.state.passage.slashcontent),
                    randomTitle: this.state.randomCorrect[Math.floor(Math.random()*this.state.randomCorrect.length)]
                });
                this.startTimer();

                window.addEventListener('resize', this.theEventListener, true);
            }
        }, (error) => {
            this.props.history.push('/student/tasks/slashtest');
            console.log('ResponseError', error);
        });
        }
        await this.setState({
            analytics: {
                type: TRACKING.STUDENT_SLASH_START,
                metadata: {}
            }
        })
        this.handleAnalytics();
    }


    calculateExpected() { //expected: list of indices of space characters, started from 0
        let passage = this.state.passage.slashcontent, expected = [];
        passage.split('').map((item, index) => {
            if (item === ' ') {
                expected.push(index);
            }
        });
        console.log('Expected', expected);
        return expected;
    }

    async handleSurveyBack(){

    }

    startTimer() {
        if(!this.props.practice) {
            this.props.backBtn(false);
        }
        this.timer = setInterval(this.countDown, 1000);
    }

    countDown() {
        let seconds = this.state.time - 1;
        this.setState({time: seconds, sessionTime: MaxSessionTime});
        if (seconds === 0) {
            clearInterval(this.timer);
            this.handleFinished();
        }
    }

    removeSpaces(target) {
        let regex = /\s/g;
        return target.replace(regex, '');
    }

    //assign value to response
    handleClick = async (index, isBreak) => {
        let {response} = this.state;
        console.log("handle click at parent level");
        console.log(index);
        console.log(isBreak);
        console.log(response);
        if (isBreak) {
            response.push(index);
        } else {
            let i = response.indexOf(index);
            if (i > -1) {
                response.splice(i, 1);
            }
        }
        console.log(response);
        response.sort(function (a, b) {
            return a - b
        });
        console.log(response);
        await this.setState({response: response}, () => {
            this.generatedText(index, isBreak);
            console.log("handle click - expectedToPop");
            console.log(this.state.expectedToPop);
        });
    };

    setLastOffset = async (offsetTop) => {
        await this.setState({
            lastOffset: offsetTop
        });
    };

    // add space to in between breaks of words, save to generatedResponse
    // the initial status of generated response is the slash content without spaces
    // however, generated response is not used in the other part of the code
    generatedText(index, isBreak) {
        String.prototype.splice = function (idx, rem, str) {
            return this.slice(0, idx) + str + this.slice(idx + Math.abs(rem));
        };
        let content = this.state.generatedResponse;
        if (isBreak) {
            content = content.splice(index, 0, ' ');
        } else {
            content = content.slice(index);
        }
        this.setState({generatedResponse: content}, () => {
            console.log('S(p)liced (' + index + '): ', this.state.generatedResponse);
            console.log(isBreak);
            console.log(content);
        });
    }

    // calculated correct, error, skipped based on nolinebreak (item - 1);
    handleFinished(e) {
        console.log('finish expected to pop:');
        console.log(this.state.expectedToPop);
        const timeStart = MaxSessionTime;
        clearInterval(this.timer);
        if(!this.props.practice) {
            this.props.backBtn(true);
        }
        if(this.state.time > timeStart - 5 && !this.props.practice && this.state.passage.slashcontent.length > 30){
            this.setState({
                tooFast:true,
                finished: true,
                showNext: true
            });
        }
        else {
            let {response, expected, correct, error, skipped, expectedToPop} = this.state;
            console.log('finish response:');
            console.log(response);
            console.log(this.state.expected); //expected start from 0
            console.log(this.state.expectedToPop);
            response.map((item) => {
                console.log('expectedToPop: ' + expectedToPop);
                let notLineBreak = !this.state.expectedToPop.includes(item - 1); //?
                if (this.state.expected.includes(item) && notLineBreak) {
                    console.log('correct item: ' + item);
                    correct += 1;
                } else if (notLineBreak) {
                    console.log('error item: ' + item);
                    error += 1;
                }
            });
            this.state.expected.map((item) => {
                if (!response.includes(item)) {
                    skipped += 1;
                }
            });

            let scoreFalse = error;
            this.setState({
                correct: correct,
                error: scoreFalse,
                skipped: skipped,
                tooFast: false,
                finished: true,
                showNext: true,
                testScore: correct
            }, () => {
                if (this.validateSession()) {
                    if (!this.props.practice) {
                        this.calculateAndUpdateScore();
                    }
                }
            });
        }
    }

    validateSession() {
        let {response, time} = this.state;
        return response.length > 0 && time < MaxSessionTime;
    }

    async calculateAndUpdateScore() {
        let {error, correct, skipped, level, score, isNewLevel, stepType} = this.state;
        if (correct !== 0 && error === 0 && skipped === 0) {
            score = score + 1;
            this.setState({stepDir:'UP'});
            if (score > 6) {
                level = level + 1;
                score = 1;
                isNewLevel = true;
                stepType ="UP";
                this.setState({lastScore:true});
            }
        }
        else if(skipped !==0 && error===0 && correct===0) {
            score = score;
            level = level;
            this.setState({stepDir:null});
        }
        else {
            score = score - 1;
            if (score < 1) {
                if (level >= 2) {
                    let testsAmount = 0;
                    await REST.getSlashScoreCount().then((response) => { //only allow level up in the first 15 tests
                        if (response.success) {
                            testsAmount = response.body;
                            if(testsAmount < 20){  //only allow level down in the first 20 tests
                                level = level - 1;
                                score = 2;
                                this.setState({stepDir:'DOWN'});
                                this.setState({levelType: 'LEVEL DOWN'});
                                isNewLevel = true;
                            }else{
                                score = 1;
                                this.setState({stepDir:null});
                            }
                            console.log('Success', response);
                        } else {
                            console.log('Error', response.msg);
                        }
                    }, (error) => {
                        console.log('Error', error.msg);
                    });
                } else {
                    score = 1;
                    level = 1;
                    this.setState({stepDir:null});
                }
            }else{
                this.setState({stepDir:'DOWN'});
            }
        }

        this.props.changeLevelScore(level, score);

        this.setState({
            scoreCalc: score,
            levelCalc: level,
            isNewLevelCalc: isNewLevel,
            stepType:stepType}, () => {
                this.updateScores();
                this.postSession();
        });
    }

    updateScores() {
        let body = {slashLevel: this.state.levelCalc, slashScore: this.state.scoreCalc};
        REST.updateSlashScores(body).then((response) => {
        }, (error) => {
            console.log('Error', error);
        });
    }

    postSession() {
        let body = {
            passageId: this.state.passage.passageId,
            sessionTime: MaxSessionTime - this.state.time,
            startLevel: this.state.level,
            testScore: this.state.testScore,
            totalWrong: this.state.error + this.state.skipped,
            newLevel: 0,
            endLevel: this.state.level,
            time: MaxSessionTime - this.state.time,
        };
        REST.postSlashSession(body).then((response) => {
            console.log('Slash Response', response);
        }, (error) => {
            console.log('Slash Error', error);
        });

    }

    handleLevelAnimationClose(){
        this.setState({animateLevel: false});
        this.state.level == 13 ? window.location.reload() : null;
    }

    async handleNext(e) {
        if(this.state.firstScore) {
            this.setState({firstScore: false});
        }
        if(this.state.lastScore){
            this.setState({lastScore:false});
        }
        if(this.state.level > this.state.levelCalc){
            await this.setState({levelType: 'LEVEL DOWN'});
        }
        else if (this.state.level < this.state.levelCalc){
            await this.setState({levelType: 'LEVEL UP'});
            if(this.state.levelCalc == 9){
               await this.setState({levelType: ''});
            }
        }else{
            await this.setState({levelType: 'STAY'});
        }

        await this.setState({
            popupSurvey:false,
            score: this.state.scoreCalc != null ? this.state.scoreCalc : this.state.score,
            level: this.state.levelCalc != null ? this.state.levelCalc : this.state.level,
            isNewLevel: false,
            animateLevel: this.state.levelType==="STAY" ? false : true
        });

        await REST.getSlashTestRandom().then((response) => {
            if (response.success) {
                this.setState({passages: response.body.passages});
            } else {
                console.log('Error', response.msg);
            }
        }, (error) => {
            console.log('Error', error.msg);
        });

        await this.setState({
            passage: this.state.passages[0],
            showNext: false,
            response: [],
            expectedToPop: [],
            correct: 0,
            error: 0,
            skipped: 0,
            time: MaxSessionTime
        }, () => {
            this.setState({expected: this.calculateExpected()});
        });
        this.startTimer();
    }

    handleClose(e) {
        if(this.state.level === this.state.levelCalc){
            this.setState({
                score: this.state.scoreCalc != null ? this.state.scoreCalc : this.state.score,
                level: this.state.levelCalc != null ? this.state.levelCalc : this.state.level,
                stepDirNow: this.state.stepDir,
                isNewLevel: false}, () => {
                this.updateScores()
            });
        }

        this.setState({finished: false, popupSurvey: true});
        if(this.props.practice){
            this.props.buttonClick(0);
        }
    }

    popExpected = async (index) => {
        let newexp = this.state.expectedToPop;
        newexp.push(index);
        await this.setState({
            expectedToPop: newexp
        });
        console.log('popExpected');
        console.log(this.state.expectedToPop);
    };

    render() {
        let {correct, error, skipped} = this.state;
        let score = correct - error - skipped;
        if (score < 0) {
            score = 0;
        }
        let title;
        let iconSrc;
        if (correct === 0 && error === 0) {
            if(this.state.tooFast){
                title = 'Try Again!';
                iconSrc = null;
            }else {
                title = 'Nothing to score!';
                iconSrc = null;
            }
        } else if (error !== 0 || skipped !== 0) {
            title = 'Oops! You made a mistake';
            iconSrc = iconIncorrect;
        } else {
            title = this.state.randomTitle;
            iconSrc = iconCorrect;
        }

        let passageContent = [];
        let passageWords = this.state.passage.slashcontent.split(" ");
        //let slashcontent = 'THE BIRD SINGS A SONG';
        //let passageWords = slashcontent.split(" ");
        let wordIndex = 0;
        let wordLengths = 0;
        let totalWidths = 0;
        let minWidths = 0;
        let moreWidthIndexes = [];
        let pwls = 0;
        let lastMinWidth = 0;
        let lastMaxWidth = 0;
        let lastLength = 0;
        let lineNumber = 0;
        let lastLenIndex = 0;
        for(let i=0;i<passageWords.length;i++){
            let passageWord = passageWords[i];
            pwls = pwls + passageWord.length;
            //let maxWidth = 66*passageWord.length;
            let maxWidth = 66*passageWord.length;
            let minWidth = 56*passageWord.length;
            minWidths = minWidths + minWidth;
            totalWidths = totalWidths + maxWidth;
            if(lastMaxWidth>0){
                totalWidths = totalWidths+lastMaxWidth;
                lastMaxWidth = 0;
            }
            if(lastMinWidth>0){
                minWidths = minWidths+lastMinWidth;
                lastMinWidth = 0;
            }

            if(this.state.lineWidth && this.state.lineWidth.width - 120 < totalWidths){ //60
                //console.log("line width:" + this.state.lineWidth.width);
                let screenMargin = this.state.lineWidth.width - 120;
                let theLenIndex = lastLength + pwls - passageWord.length + i-1;
                let responsesUnique = this.state.response;
                responsesUnique = responsesUnique.filter(function(item, pos) {
                    return responsesUnique.indexOf(item) === pos;
                });
                let before = responsesUnique.filter((o,ln)=>{return lastLenIndex<o && o<=theLenIndex}).length;
                lastLenIndex = theLenIndex;
                let newWidth = 56*passageWords[i-1].length + minWidth + (screenMargin - minWidths) - (before*10);
                moreWidthIndexes.push({
                    wordIndex:i-1,
                    width: newWidth
                });
                lastLength = lastLength + pwls - passageWord.length;
                pwls = passageWord.length;
                totalWidths = 0;
                minWidths = 0;
                lastMaxWidth = maxWidth;
                lastMinWidth = minWidth;
                lineNumber++;
            }
        }
        for (let passageWord of passageWords) {
            let toSendContent = passageWord + " ";
            let expected = [0, passageWord.length];
            let lastWord =  passageWords.length === wordIndex + 1;
            if (lastWord) {
                toSendContent = passageWord;
                expected = [0, 0]
            }
            let widthAdd = moreWidthIndexes.find(e=>{return e.wordIndex === wordIndex});
            let cont = (
                <span key={this.state.passage.passageId + "passage" + wordIndex}
                      style={{display: "inline-block", width:widthAdd && !this.state.showNext?widthAdd.width:widthAdd}}>
                    <ChildComponent
                        key={this.state.passage.passageId + "passage" + wordIndex}
                        passageId={this.state.passage.passageId}
                        content={passageWord}
                        lastWord={lastWord}
                        handleChildClick={this.handleClick}
                        setChildLastOffset={this.setLastOffset}
                        handlePopExpected={this.popExpected}
                        expected={this.state.expected}
                        expectedToPop={this.state.expectedToPop}
                        finished={this.state.showNext}
                        response={this.state.response}
                        wordLengths={wordLengths}
                        lastOffset={this.state.lastOffset}
                    />
                </span>
            );
            passageContent.push(cont);
            wordLengths = wordLengths + passageWord.length + 1;
            wordIndex++;
        }

        return (
            <div>
                <InstructionModals
                    Slash
                    modalOpen={this.state.modalInstruction}
                    closeClick={(active)=>{this.setState({modalInstruction: active});this.props.buttonClick(0)}}
                />
                <div className={!this.props.practice ? " appSection bgGr" +
                    "ey" : "appSection bgYellow"}>
                    <DialogBox surveyModal app={'Slash'} userId={this.props.studentUser.id} active={this.state.popupSurvey} surveyBack={this.handleSurveyBack}/>
                    <div className="container-fluid">
                        <div className="container">
                            <DialogBox slash warning={isTablet ? true : false} notificationModal modalOpen={this.state.modalDialog} sectionContent={this.state.responseContent} closeClick={(active)=>{this.setState({modalDialog: active}); this.props.buttonClick(0)}} />
                        </div>
                        <div className={""} style={{marginRight:50,marginLeft:50}}>
                        <div className="row">
                            <div ref={ref => {this.theLine = ref; !this.state.lineWidth && ref ? this.setState({lineWidth:ref.getBoundingClientRect()}):null}} className={"appContainer slashTest"} style={{paddingBottom: "75px"}}>
                                {passageContent}
                            </div>
                        </div>
                        </div>
                    </div>
                </div>

                <div className="section">
                    <div className="container">
                        <div >
                            <div className="divBottomRelative tc">
                                <div className={"row tc"}>
                                    <div className={"col-sm-12 hidden-md hidden-xs hidden-lg"}>
                                        {this.state.showNext ?
                                            <a onClick={this.handleNext} className="handBtn" style={{width:150}}>
                                                <span>Try Another</span>
                                            </a> :
                                            <a onClick={this.handleFinished} className="handBtn">
                                                <span>Finished</span>
                                            </a>
                                        }
                                    </div>
                                    <div className={"col-md-5 col-sm-6"}>
                                        <div hidden={this.props.practice}>
                                        <LevelTrackerComponent appName={"slash"} firstScore={this.state.firstScore} lastScore={this.state.lastScore} stepDir={this.state.stepDirNow} level={this.state.level} maxLevel={8} step={this.state.score} stepType={this.state.stepType}
                                                                   steps={6}/>
                                        </div>
                                    </div>
                                    <div className={"col-md-2 hidden-sm"}>
                                        {this.state.showNext ?
                                            <a onClick={this.handleNext} className="handBtn" style={{width:150}}>
                                                <span>Try Another</span>
                                            </a> :
                                            <a onClick={this.handleFinished} className="handBtn">
                                                <span>Finished</span>
                                            </a>
                                        }
                                    </div>
                                    <div className={"col-md-5 col-sm-6"}>
                                        <div className={"row pull-right"}>
                                                <CountDownComponent time={this.state.time} sessionTime={MaxSessionTime} showTime={10}/>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <Modal id={"resultBox"} show={this.state.finished}>
                    <div className="modal-content">
                        <div className="modal-header">
                            {iconSrc ?
                                <img src={iconSrc} style={{width:150}} />
                                :
                                null
                            }
                            <h4>{title}</h4>
                        </div>
                        <div className={"row modal-body"}>
                            { title !=='Nothing to score!' && !this.state.tooFast ?
                                <ScoreBox
                                    score={score}
                                    correct={correct}
                                    incorrect={error + skipped}
                                    skipped={skipped}
                                    app={"slash"}
                                />
                            :
                                null
                            }
                        </div>
                        <div className="modal-footer">
                            <a className="handBtn" onClick={this.handleClose}>
                                <span>Close</span>
                            </a>
                        </div>
                    </div>
                </Modal>
                <Modal id="animateModal" show={this.state.animateLevel}>
                    <div className="modal-content" >
                        <div className={"modal-body"}>
                            <LevelAnimation appName={"slash"} level={this.state.level} maxLevel={8} typeLevel={this.state.levelType} closeAnimation={this.handleLevelAnimationClose}/>
                        </div>
                    </div>
                </Modal>
            </div>
        );
    }
}


class Tutorial extends Component {

    constructor(props) {
        super(props);
        this.state = {passage: this.props.passage};
    }

    render() {
        let passages = [];
        passages.push({slashcontent:"I HAVE A BIG BROWN DOG"});
        return (
            <Content studentUser={this.props.studentUser} buttonClick={this.props.buttonClick} passages={passages} practice={true}/>
        );
    }
}

const Content = withRouter(ContentComponent);

class ChildComponent extends Component {
    constructor(props) {
        super(props);
        this.state = {
            response: [],
            timeout:null,
            reloaded:true,
        };
    }

    componentWillUnmount(){
        clearTimeout(this.state.timeout);
    }

    async componentDidMount() {
        console.log('expected to pop 1');
        console.log(this.props.expected);
        console.log(this.props.expectedToPop);
        if(this.state.reloaded) { //only run once
            let timeout = setTimeout(async () => {
                let offsetTop = await ReactDOM.findDOMNode(this)
                    .getBoundingClientRect()
                    .top;

                let lastOffset = this.props.lastOffset;
                let wl = this.props.wordLengths;
                await this.props.setChildLastOffset(offsetTop);
                console.log('handel pop expected: '+this.props.content);
                console.log(wl);
                console.log(lastOffset);
                console.log(offsetTop)
                if (lastOffset !== -1 && offsetTop > lastOffset) { //remove the last one if current one's offset > last one's
                    this.handleClick(wl - 2); //wl - 2
                    await this.props.handlePopExpected(wl - 2); //wl - 2
                    console.log('expected to pop 2');
                    console.log(this.props.expectedToPop);
                }
            }, 500);

            this.setState({
                timeout: timeout,
                reloaded: false
            });
        }
    }

    async handleClick(index) {
        let response = this.state.response;
        console.log('parent handle click: response 1');
        console.log(response);
        if (response.includes(index)) {
            let i = response.indexOf(index);
            if (i > -1)
                response.splice(i, 1);
            await this.props.handleChildClick(index + 1, false); //generate text
        } else {
            response.push(index);
            await this.props.handleChildClick(index + 1, true); //generate text
        }
        console.log('response 2');
        console.log(response);
        await this.setState({response: response});
    }

    prepareContent() {
        let content = this.props.content;
        let items = content.split('');
        let array = [];

        let wordsIndex = this.props.wordLengths;

        let middleGroup = null;
        let lastWord = this.props.lastWord;

        items.map((item, index) => {
            let correct = false, skipped = false, error = false, spacing=false;
            let lastCharacter = content.length === (index + 1);
            let isLineBreak = this.props.expectedToPop.includes(wordsIndex + index);//handle line break
            if (this.props.finished) {
                if (this.props.expected.includes(wordsIndex + index + 1) && this.props.response.includes(wordsIndex + index + 1) && !isLineBreak) {
                    correct = true;
                } else if (this.props.expected.includes(wordsIndex + index + 1) && !this.props.response.includes(wordsIndex + index + 1) && !isLineBreak) {
                    skipped = true;
                } else if (!this.props.expected.includes(wordsIndex + index + 1) && this.props.response.includes(wordsIndex + index + 1) && !isLineBreak) {
                    error = true;
                }else{
                    spacing = true;
                }
                if(this.state.response.length>0){
                    this.setState({
                        response:[],
                        reloaded:true
                    });
                }
            } else {
                let sClass = "";
                if (this.state.response.includes(wordsIndex + index) && !this.props.finished && !this.state.lastIndex && !isLineBreak) {
                    sClass = "show";
                }
                let hoverEnabled = sClass==="" && !isLineBreak ? "hoverEnabled": "";
                middleGroup = (
                    !!navigator.platform && /iPad|iPhone|iPod/.test(navigator.platform) ?
                        <Tappable onTap={() => {
                            if(!isLineBreak) {
                                this.handleClick(wordsIndex + index);
                            }else{
                                return null;
                            }}} >
                    <div style={{cursor: !isLineBreak ? "pointer" : "default"}} key={wordsIndex + index} className={"slashOptions "+ hoverEnabled}>
                        <div className={"vll " + sClass}></div>
                    </div>
                        </Tappable>
                        :
                        <div style={{cursor: !isLineBreak ? "pointer" : "default"}} key={wordsIndex + index} className={"slashOptions "+ hoverEnabled} onClick={() => {
                            if(!isLineBreak) {
                                this.handleClick(wordsIndex + index);
                            }else{
                                return null;
                            }
                        }}>
                            <div className={"vll " + sClass}></div>
                        </div>
                );
            }
            if (item === ' ') {
                return;
            }

            const theItem = (
                <div className="slashOptions" style={{position:'relative'}} key={index}>
                    <span>{item}</span>
                    {lastWord && lastCharacter ? null: middleGroup}
                    {this.props.finished && correct ?
                        <div key={wordsIndex + index} className={"slashCorrect slashOptions"}>
                            <div className={"fdbkPlus"}></div>
                        </div>: null
                    }
                    {this.props.finished && spacing ?
                        <div key={wordsIndex + index} className={"slashOptions"}>
                            <div className={"vll"}></div>
                        </div>: null
                    }
                    {this.props.finished && error ?
                        <div key={wordsIndex + index} className="slashError slashOptions">
                            <div className={"fdbkMinus"}></div>
                        </div> : null
                    }
                    {this.props.finished && skipped ?
                        <div key={wordsIndex + index} className="slashSkipped slashOptions">
                            <div className={"dashedSkip"}></div>
                            <div className={"fdbkMinus"}></div>
                        </div> : null
                    }
                </div>);

            array.push(theItem);
        });
        return array;
    }

    render() {
        let items = this.prepareContent();
        if (this.props.finished) {
            //console.log('Finished', this.props.response);
        }
        return (
            <div className="slashOptions">
                {items}
            </div>
        );
    }
}

const bindActionToProps = dispatch => {
    return {
        updateStudentAppStatus: async(results) => await dispatch(updateStudentAppsStatus(results)),
        updateStudentAccountTab:async(tabNum) => await dispatch(updateStudentAccountTab(tabNum)),
        updateAppStates:async(appStates) => await dispatch(updateAppStates(appStates))
    };
};

const mapStateToProps = state => ({
    apps:state.studentReducer.apps,
    tabNum: state.studentReducer.tabNum,
    studentUser: state.studentReducer.studentUser,
    appStates: state.studentReducer.appStates
});

export default connect(mapStateToProps,bindActionToProps)(withRouter(SlashTestComponent));


// WEBPACK FOOTER //
// ./src/StudentsComponent/SlashTest.js